import { render, staticRenderFns } from "./MasteryModel.vue?vue&type=template&id=47f1fad8&scoped=true"
import script from "./MasteryModel.vue?vue&type=script&lang=js"
export * from "./MasteryModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f1fad8",
  null
  
)

export default component.exports